import { calculateValue } from 'checkout/selectors/payment/generic'

interface TicketViewOptions {
  isBookDates?: boolean
  orderItemId?: string,
  ticketValidation?: App.ExperienceCheckoutItemValidationState['string'],
  isAccomBundle?: boolean
}

/**
 * Iterate through the item in the cart and sum the price and memberPrice
 * @param cartTicketItem
 * @param ticket
 * @param options
 * @returns
 */
export function mapExperienceCartItemToSummaryViews(
  cartTicketItem: App.Checkout.ExperienceItemTicket,
  ticket: App.ExperienceItemTicket | undefined,
  options: TicketViewOptions = {},
): App.Checkout.ExperienceItemTicketSummaryView | undefined {
  const { ticketId, count } = cartTicketItem

  const ticketPrice = ticket?.price ?? 0
  const ticketMemberPrice = ticket?.memberPrice ?? 0

  const isZeroPriced = options.isBookDates || options.isAccomBundle
  let price = isZeroPriced ? 0 : ticketPrice * cartTicketItem.count
  let memberPrice = isZeroPriced ? 0 : ticketMemberPrice * cartTicketItem.count

  if (cartTicketItem.loyaltyTransferDiscount && price) {
    // this is our special loyalty transfer discount, so make one of the items 'free'
    price -= ticketPrice
    memberPrice -= ticketMemberPrice
  }

  if (cartTicketItem.count === 0) {
    return undefined
  }

  const isTicketValid = !options.ticketValidation || options.ticketValidation.fetching || options.ticketValidation.isValid

  return {
    ticketId,
    name: ticket?.name ?? cartTicketItem.name,
    fareType: ticket?.fareType ?? '',
    price,
    memberPrice,
    value: options.isAccomBundle ? 0 : calculateValue(price, ticket?.discounts.base.percentage ?? 0),
    discounts: {
      base: {
        amount: options.isAccomBundle ? 0 : (ticket?.discounts.base.amount ?? 0),
        percentage: options.isAccomBundle ? 0 : (ticket?.discounts.base.percentage ?? 0),
      },
      app: {
        amount: options.isAccomBundle ? 0 : (ticket?.discounts.app.amount ?? 0),
        percentage: options.isAccomBundle ? 0 : (ticket?.discounts.app.percentage ?? 0),
      },
    },
    count,
    unavailable: !ticket || !isTicketValid,
    purchaseLimit: ticket?.purchaseLimit ?? { min: 1, max: 9999, maxReason: 'AVAILABILITY' },
    taxesAndFees: options.isAccomBundle ? 0 : (ticket?.taxesAndFees ?? 0),
    participantsPerUnit: ticket?.participantsPerUnit ?? 1,
    numberOfAdults: ticket?.numberOfAdults,
    numberOfChildren: ticket?.numberOfChildren,
    date: ticket?.date,
    time: ticket?.time,
  }
}
